// extracted by mini-css-extract-plugin
export default {"menu":"C10vm","item":"lLuSr","itemIcon":"I8u4y","itemText":"oYDsl"};